import { defaultConfigurationKeys16 } from '../ocpp-core/configuration'

// The OCPP 1.6 configuration keys the emulator starts with: every standard key the simulated
// charge point supports (Core, Firmware Management, Local Auth List, Reservation, Smart Charging,
// Security), with the defaults and read-only flags of ocpp-core, plus EVsafe vendor keys.
// NumberOfConnectors and SupportedFileTransferProtocols are derived at runtime.
const stationSettings = {
  configurationKey: [
    ...defaultConfigurationKeys16(),
    // EVsafe vendor keys
    { key: 'PricePerKwh', readonly: false, value: '0' },
    { key: 'AllowOfflineTxForFreemode', readonly: false, value: 'false' },
  ],
  unknownKey: []
}

export default stationSettings
